import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import DateRangePicker from '../../../../components/v3/DateRangePicker/DateRangePicker';
import { CalibrationStatus } from '../../../../generated';
import LoadingControl from '../../../../components/LoadingControl';
import PieChart from '../../../../components/v3/Graphs/Calibration/PieChart';
import GeneralQuestionCodeChartContainer from '../../../../components/v3/Graphs/ChartContainer/GeneralQuestionCodeChartContainer';
import ThumbsUpIcon from '../../../../icons/ThumbsUpIcon';
import ThumbsDownIcon from '../../../../icons/ThumbsDownIcon';
import { isDefined, arrayIsNotEmpty, getPieChartColorSet, cloneArray } from '../../../../utils';
import moment from "moment";
import { dateTimeFormat } from '../../../../constants';

class AgentJibeOvertimeAndDetailOnSurveyQuetions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fromDate: moment().startOf('day').subtract(91, 'd').format(dateTimeFormat),
            toDate: moment().subtract(-1, 'd').endOf('day').format(dateTimeFormat),
            defaultFromDate: moment().startOf('day').subtract(91, 'd').format(dateTimeFormat),
            defaultToDate: moment().subtract(-1, 'd').endOf('day').format(dateTimeFormat)
        };

        this.getTabPanel = this.getTabPanel.bind(this);
    }

    onSelectNewTimeRange = (fromDate, toDate) => {
        const
            {
                onSelectNewTimeRange
            } = this.props;
        this.setState({ fromDate: fromDate, toDate: toDate });
        onSelectNewTimeRange(fromDate, toDate);
    }

    getTabPanel(calibratedOnSurveyQuestion) {
        const
            {
                agentInteractions,
                agentCalibrationSummary
            } = this.props;

        if (!isDefined(agentInteractions) || !isDefined(agentCalibrationSummary)) {
            return <TabPanel key={calibratedOnSurveyQuestion.id}
                style={{
                    height: '509px', position: 'relative',
                    border: '2px solid #70CFD6',
                    borderRadius: '20px',
                    padding: '8px 28px'
                }}>
                <LoadingControl />
            </TabPanel >;
        }

        let agentInteractionsCopy = cloneArray(agentInteractions);

        if (this.state.fromDate != this.state.defaultFromDate || this.state.toDate != this.state.defaultToDate) {
            const from = new Date(this.state.fromDate);
            const toDate = new Date(this.state.toDate);
            agentInteractionsCopy = agentInteractionsCopy.filter(ai => new Date(ai.externalOpenDate) >= from && new Date(ai.externalOpenDate) <= toDate);
        }

        let isJibed = false;
        const calibrationStatusId = `${calibratedOnSurveyQuestion.internalName}CalibrationStatusId`;
        const statusId = agentCalibrationSummary[calibrationStatusId];
        if (statusId === 1) {
            isJibed = true;
        }

        const agentInteractionsWithResponseOnQuestion = agentInteractionsCopy.filter(ai => ai.questionCode === calibratedOnSurveyQuestion.questionCode
            && isDefined(ai.customerResponse));

        const accuratePredictions = agentInteractionsWithResponseOnQuestion.filter(ai =>
            ai.responsesMatch === true);

        const agentPredictionsOnQuestion = agentInteractionsWithResponseOnQuestion.map(ai => ai.agentResponse);

        const customerMappedResponseOnQuestion = agentInteractionsWithResponseOnQuestion.map(ai => ai.customerMappedResponse);

        let responseDiffer = 0;
        let responseToPredictMore;
        let customerDataPoints = [];
        let agentDataPoints = [];
        calibratedOnSurveyQuestion.responses.map(r => {

            const customePredictions = customerMappedResponseOnQuestion.filter(a => a === r);
            const customePredictionCount = customePredictions ? customePredictions.length : 0;
            const customepercentage = (100 * customePredictionCount / agentPredictionsOnQuestion.length).toFixed(2);
            const customerItem = {
                label: r,
                value: customepercentage
            };

            customerDataPoints.push(customerItem);

            const agentPredictions = agentPredictionsOnQuestion.filter(a => a === r);
            const agentPredictionCount = agentPredictions ? agentPredictions.length : 0;
            const agentPercentage = (100 * agentPredictionCount / agentPredictionsOnQuestion.length).toFixed(2);
            const agentItem = {
                label: r,
                value: agentPercentage
            };
            agentDataPoints.push(agentItem);

            if (customepercentage - agentPercentage > responseDiffer) {
                responseDiffer = customepercentage - agentPercentage;
                responseToPredictMore = r;
            }
        });

        const avatarBackground = 'linear-gradient(91.89deg, #FF7700 -6.8%, #FFB06B 100.34%)';
        const firstLetter = calibratedOnSurveyQuestion.shortName.charAt(0).toUpperCase();

        let jibeStatusAndIcon = isJibed
            ? (<p className="H1-24">{calibratedOnSurveyQuestion.shortName}
                <span className="H1-24-2">Jibed</span>
                <span style={{ margin: '0 0 0 3px' }} ><ThumbsUpIcon /></span>
            </p>)
            : (<p className="H1-24">{calibratedOnSurveyQuestion.shortName}
                <span className="H1-24-3">Not Jibed</span>
                <span style={{ margin: '6px 0 0 3px' }} ><ThumbsDownIcon /></span>
            </p>);

        const questionNameAvatar = (
            <div style={{ flex: '0 1 50px', textAlign: '-webkit-center' }}>
                <div className="flex-item" >
                    <div style={{
                        background: avatarBackground,
                        borderRadius: '16px',
                        display: 'inline-block',
                        width: '68px',
                        color: 'white',
                        marginRight: '10px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        fontSize: '47px',
                        fontFamily: 'Roboto'
                    }}>
                        {firstLetter}
                    </div>
                </div>
            </div>
        );

        //const jibedSinceNode = (agentCalibrationDetailOnSurveyQuetion.calibrationStatus == CalibrationStatus.Jibed) ?
        //    <p className="H2-white">Jibed since : Jun 4, 2020</p> : <p className="H2-white">-</p>
        // {jibedSinceNode}

        const topLefttArea = (
            <div style={{ flex: '0 1 227px', textAlign: '-webkit-center' }}>
                <div className="flex-item" >
                    {jibeStatusAndIcon}
                </div>
            </div>
        );

        let tipToGetJibed;
        if (Math.abs(responseDiffer) > 0) {
            tipToGetJibed = isJibed
                ? `Predict '${responseToPredictMore}' more often`
                : `Predict '${responseToPredictMore}' more often to get Jibed`;
        }
        const topRightArea = (
            <div style={{ marginLeft: 'auto', marginTop: '16px' }}>
                <p className="agent-bottom-panel-title" style={{ marginBottom: '20px' }}>
                    {tipToGetJibed}
                </p>
            </div>
        );

        const accuratePredictionCount = (<div
            style={{ marginLeft: 'auto', padding: '0 25px' }}>
            <div className="flex-container" style={{ margin: '5px 0' }}>
                <p className="agent-bottom-panel-title">Accurate Predictions: {accuratePredictions.length} of {agentPredictionsOnQuestion.length}
                </p>
            </div>
            {/*
            <div className="flex-container" style={{ margin: '5px 0' }}>
                <p className="agent-bottom-panel-title" >Customer Responses:
                    <span style={{
                        width: '93px',
                        height: '0px', borderTop: '2px dashed #98DDE1'
                    }}></span>
                </p>
                <p className="agent-bottom-panel-stats" >{agentPredictionsOnQuestion.length}</p>
            </div>
            */ }
        </div>);

        const topArea = (
            <div className="flex-container" style={{ minHeight: '80px', padding: '10px 0', borderBottom: '2px solid #70CFD6' }}>
                {questionNameAvatar}
                {topLefttArea}
                {topRightArea}
                {accuratePredictionCount}
            </div>
        );

        let agentColorsSet = getPieChartColorSet(agentDataPoints);
        let customerColorsSet = getPieChartColorSet(customerDataPoints);

        const graphCustomer = (
            <div className="flex-item" style={{ width: '350px', height: '350px' }}>
                <div style={{ justifyContent: 'center' }} className="agent-bottom-panel-title"> Customer Said </div>
                <PieChart colors={customerColorsSet} propId="pieChart4" dataPoints={customerDataPoints} />
            </div>
        );

        const graphAgent = (
            <div className="flex-item" style={{ width: '350px', height: '350px' }}>
                <div style={{ justifyContent: 'center' }} className="agent-bottom-panel-title">Agent Predicted </div>
                <PieChart colors={agentColorsSet} propId="pieChart5" dataPoints={agentDataPoints} />
            </div>
        );
        const graphsArea = agentInteractionsCopy.length > 0 ? (
            <div className="flex-container" style={{ padding: '20px 0' }} >
                {graphCustomer}
                {graphAgent}
            </div>
        ) : (<div>No data for the selected time range</div>);

        return (
            <TabPanel key={calibratedOnSurveyQuestion.id}
                style={{
                    height: '509px', position: 'relative',
                    border: '2px solid #70CFD6',
                    borderRadius: '20px',
                    padding: '8px 28px'
                }}>
                {topArea}
                {graphsArea}
            </TabPanel >);
    }

    render() {
        const
            {
                calibratedOnSurveyQuestions,
                agentJibeProgressOverTimeStats
            } = this.props;

        if (!isDefined(calibratedOnSurveyQuestions))
            return (<LoadingControl />);

        const tabHeaders = calibratedOnSurveyQuestions.map((q, index) =>
            <Tab key={index} style={{ fontSize: 'x-large' }}>
                {q.shortName}
            </Tab>
        );
        tabHeaders.unshift(<Tab key='overtime' style={{ fontSize: 'x-large' }}>
            Prediction Accuracy
        </Tab>);

        const panels = calibratedOnSurveyQuestions.map((q, index) => {
            const panel = this.getTabPanel(q);
            return panel;
        });

        const overTimeGraph = arrayIsNotEmpty(agentJibeProgressOverTimeStats)
            ? (<div style={{ padding: '68px' }}>
                <GeneralQuestionCodeChartContainer
                    valueType="overalSuccessRatePercent"
                    maxX={110}
                    suffixY=" %"
                    chartType="spline"
                    calibratedOnSurveyQuestions={calibratedOnSurveyQuestions}
                    jibeProgressOverTimeStats={agentJibeProgressOverTimeStats}
                    propId="JibeProgressOverTimeChart12" />
            </div>) : undefined;
        panels.unshift(<TabPanel key="progressOverTimePanel"
            style={{
                height: '509px', position: 'relative',
                border: '2px solid #70CFD6',
                borderRadius: '20px',
                padding: '8px 28px'
            }}>
            {overTimeGraph}
        </TabPanel>);
        return (
            <div>
                <div className="flex flex-container-end">
                    <DateRangePicker
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}
                        onClose={this.onSelectNewTimeRange} />
                </div>
                <Tabs>
                    <TabList className="react-tabs-left">
                        {tabHeaders}
                    </TabList>
                    {panels}
                </Tabs>
                <br />
            </div>);
    }
}

const select = state => ({ ...state.CalibrationV3Screen });

export default connect(select)(AgentJibeOvertimeAndDetailOnSurveyQuetions);